import { betterFetch as defaultFetch } from '@e-socna/better-fetch';
import type { BetterFetch } from '@e-socna/better-fetch';

import { georisquesRetryStrategy } from './strategies/retry.strategy';

/**
 * Create a configured fetcher for georisques API with automatic retry handling
 *
 * @param fetch - Optional custom fetch implementation (defaults to betterFetch)
 * @returns A configured fetch function with retry strategy
 *
 * @example
 * ```typescript
 * import { createGeorisquesFetcher } from '@e-socna/gis';
 *
 * const georisquesFetch = createGeorisquesFetcher();
 * const data = await georisquesFetch<CaviteResult>(url);
 * ```
 */
export const createGeorisquesFetcher =
  (fetch: BetterFetch = defaultFetch) =>
  <T>(url: string, options?: RequestInit) =>
    fetch<T>(url, options ?? {}, {
      retryStrategy: georisquesRetryStrategy,
      retries: 5,
    });
